
import React from 'react';
import { XCircle, CheckCircle, TreeDeciduous, ArrowRight } from 'lucide-react';

const competitors = [
  "Mailchimp",
  "Calendly",
  "Salesforce",
  "Wix",
  "Podium"
];

const WheelSection: React.FC = () => {
  const scrollToForm = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 bg-white text-[#0F1419] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-20">
          {/* Wheel Visual */}
          <div className="flex-1 relative order-2 lg:order-1">
            <div className="w-80 h-80 md:w-[500px] md:h-[500px] border-8 border-dashed border-[#F4E4C1] rounded-full flex items-center justify-center relative animate-[spin_60s_linear_infinite]">
              {competitors.map((name, idx) => {
                const angle = (idx / competitors.length) * 2 * Math.PI;
                const dist = 220; // Fixed distance for rotation
                const x = Math.cos(angle) * dist;
                const y = Math.sin(angle) * dist;
                return (
                  <div 
                    key={idx} 
                    className="absolute bg-white p-5 shadow-2xl rounded-2xl border-2 border-red-100 flex flex-col items-center gap-1 transform transition-all group hover:scale-110"
                    style={{ left: `calc(50% + ${x}px - 45px)`, top: `calc(50% + ${y}px - 45px)` }}
                  >
                    <div className="relative">
                      <span className="font-black text-[#4E3629] text-xs uppercase tracking-widest whitespace-nowrap opacity-50">{name}</span>
                      <XCircle className="absolute -top-10 -right-10 w-10 h-10 text-red-500 fill-white drop-shadow-lg" />
                    </div>
                  </div>
                );
              })}
            </div>
            {/* Center Logo */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#1A4D2E] p-10 rounded-3xl shadow-[0_30px_60px_rgba(26,77,46,0.4)] flex flex-col items-center gap-4 z-10 border-4 border-[#F4E4C1] scale-110">
              <TreeDeciduous className="w-16 h-16 text-white" />
              <span className="text-white font-black text-center text-xs leading-none uppercase tracking-tighter">THE ONLY<br/>PLAYBOOK<br/>YOU NEED</span>
            </div>
          </div>

          {/* Copy Content */}
          <div className="flex-1 order-1 lg:order-2">
            <span className="text-[#FF6B35] font-black uppercase tracking-[0.3em] text-sm mb-6 block">Profit Retention System</span>
            <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase italic leading-none tracking-tighter">Stop Burning Cash On Overhead</h2>
            <p className="text-xl text-[#4E3629] mb-10 leading-relaxed font-bold italic">
              Most tree pros are death-by-a-thousand-cuts. Separate tools for email, SMS, your site, and scheduling. That’s wasted profit leaking out of your chipper truck. 
              <br /><br />
              Arbor Advantage replaces the "Subscription Bloat" with one high-performance partnership.
            </p>
            <ul className="space-y-6 mb-12">
              {[
                "No more broken integrations between generic apps.",
                "No more logging into 5 different tabs while in the field.",
                "One partner. One system. One predictable win."
              ].map((item, idx) => (
                <li key={idx} className="flex items-center gap-4 text-lg font-black uppercase italic tracking-tight text-[#1A4D2E]">
                  <CheckCircle className="w-7 h-7 text-[#FF6B35]" />
                  {item}
                </li>
              ))}
            </ul>
            <div className="flex flex-col items-start gap-4">
              <button 
                onClick={scrollToForm}
                className="bg-[#1A4D2E] hover:bg-[#FF6B35] text-white text-2xl font-black px-12 py-6 rounded-2xl transition-all shadow-2xl uppercase flex items-center gap-4 group tracking-tighter cursor-pointer"
              >
                CUT YOUR OVERHEAD TODAY <ArrowRight className="w-7 h-7 group-hover:translate-x-1 transition-transform" />
              </button>
              <p className="text-[#FF6B35] font-black uppercase text-xs tracking-widest animate-pulse ml-2">
                ONLY 7 SPOTS LEFT THIS MONTH
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WheelSection;
